import React from 'react'
import { Content } from './Content'
import { Header } from './Header'
import { Container } from './styles'
import { CheckUpProvider } from '~/context'

export const MetabolicSyndromePrediction = (): JSX.Element => {
  return (
    <CheckUpProvider>
      <Container>
        <Header />
        <Content />
      </Container>
    </CheckUpProvider>
  )
}
